export const SlidersCircleHorizontal = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 7H28" stroke="currentColor" stroke-width="2"/>
<path d="M15 25H28" stroke="currentColor" stroke-width="2"/>
<path d="M17 16L4 16" stroke="currentColor" stroke-width="2"/>
<circle cx="7" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="7" cy="25" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="25" cy="16" r="3" transform="rotate(-180 25 16)" stroke="currentColor" stroke-width="2"/>
</svg>`;
